import React, { useEffect,useState } from 'react';
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";
import { withRouter} from "react-router-dom";
import YesNoComponent from "../common/YesNoComponent";
import { connect } from "react-redux";
import * as types from "../../constants/actionTypes";

const OnboardingHeader = (props) => {

    useEffect(() => {
        logUI("MBHWeb.UI.OnboardingHeader.ComponentDidMount", new Date(), Tools.getURLPath());
    }, [])

    const LogUpdatePath=(pathLog)=> {
        const { selectedProxySuggestionUsers, hasSelectedProxySuggestionUsers, clearProxySuggestionUsers } = props;
        logUI(`MBHWeb.UI.OnboardingHeader.Clicked`, new Date(), Tools.getURLPath(),
            {
                path: pathLog,
                ...(hasSelectedProxySuggestionUsers && { selectedUserCount: selectedProxySuggestionUsers.length, selectedUsers: selectedProxySuggestionUsers}) 
            });
        if (hasSelectedProxySuggestionUsers)
            clearProxySuggestionUsers();
    }

    const path = location.pathname;
    const pathLog = path.substring(1);
    const [show, setShow] = useState(false);

    const toggle = () => setShow(!show);

    const modalClicked = (option) => {
        toggle();        
        if (option.toUpperCase() === 'YES') {
            LogUpdatePath(`${pathLog}`);
            props.history.push('/');
        }
    }


    return (
        <div className="row onboarding-layout__header">
   
            <div className="col-12" >
             <a href='#' onClick={toggle}>
                <span>
                    <img alt="MyBSWHealth" className="img-fluid" src="/images/mybswlogo.svg" />
                </span>
             </a>
            </div>

            <YesNoComponent showModal={show}
                modalText={'Are you sure you want to exit the onboarding experience? These settings can be adjusted later.'}
                modalYesFunction={() => modalClicked('YES')}
                modalNoFunction={() => modalClicked('NO')}
             />        
           
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        selectedProxySuggestionUsers: state.session.selectedProxySuggestionUsers,
        hasSelectedProxySuggestionUsers: state.session.hasSelectedProxySuggestionUsers

    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        clearProxySuggestionUsers: () => dispatch({ type: types.CLEAR_PROXY_SELECTED_USERS })       
    }
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(OnboardingHeader));
